// @flow

import { combineReducers } from 'redux-immutable';

import modalEscolhaTipoRelatorio from './modal_escolha_tipo_relatorio';
import salvarRelatorio from './salvar_relatorio';
import modalListaRelatorios from './modal_lista_relatorios';

export default combineReducers({ modalEscolhaTipoRelatorio, salvarRelatorio, modalListaRelatorios });
